import { Button, Space } from "antd"

interface ButtonProps {
  continueMsg?: string;
  cancelMsg?: string;
  continueDisabled?: boolean;
  handleOk?: () => void;
  handleCancel?: () => void;
  hideCancelBtn?: boolean;
}

export const ButtonGroup: React.FC<ButtonProps> = ({ continueMsg, cancelMsg, continueDisabled, handleOk, handleCancel, hideCancelBtn }) => {
  return (
    <Space direction="vertical" align="center" id='choose-buttons'>
      <Button type="primary" shape="round" onClick={handleOk} disabled={continueDisabled} block>
        {continueMsg ? continueMsg : 'Continuar'}
      </Button>
      {!hideCancelBtn && <Button danger shape="round" onClick={handleCancel} block>
        {cancelMsg ? cancelMsg : 'Volver atrás'}
      </Button>}
    </Space>
  )
}
